import React from "react"
import PropTypes from "prop-types"
import { Cell } from "fixed-data-table-2"
// component for rendering an enum, given a display key
const EnumDisplayCell = ({
    item = {},
    displayKey = "label",
    transformFunction = val => val,
    ...props
}) => (
    <Cell {...props}>
        { transformFunction(item[displayKey]) }
    </Cell>
)

EnumDisplayCell.propTypes = {
    transformFunction: PropTypes.func.isRequired,
    displayKey: PropTypes.string,
    item: PropTypes.object,
}

export default EnumDisplayCell
